module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Sz4vC1/images/cover.jpg?1726444355258",
      "alt": "This image is the cover for the book Quiz Actually"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Quiz Actually\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("With this entertaining quiz book, you can test your knowledge of beloved Christmas movies from "), _c('i', [_vm._v("Elf ")]), _vm._v("and "), _c('i', [_vm._v("The Grinch")]), _vm._v(" to "), _c('i', [_vm._v("Love, Actually")]), _vm._v(" and even "), _c('i', [_vm._v("Die Hard")]), _vm._v("!")])]), _c('p', [_vm._v(" If Christmas movies hold a special place in your heart—and your favorite scenes, lines, and trivia facts hold a special place in your memory—you’ll love this festive family film trivia book. From rating the best (and worst) examples of the genre, to what even makes a “Christmas movie”, "), _c('i', [_vm._v("Quiz Actually")]), _vm._v(" is sure to spark lively debate around the holiday dinner table. ")]), _vm._v(" Packed full of fun and tricky trivia questions, "), _c('i', [_vm._v("Quiz Actually ")]), _vm._v("will test your knowledge of the movies we watch every holiday season—from old time favorites like "), _c('i', [_vm._v("It’s a Wonderful Life")]), _vm._v(" and "), _c('i', [_vm._v("Miracle on 34th Street")]), _vm._v(" to modern classics like "), _c('i', [_vm._v("Scrooged")]), _vm._v(", "), _c('i', [_vm._v("The Nightmare Before Christmas")]), _vm._v(", and many more.\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joe Shooman\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0